import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {ActivityPageRequest, ActivityResponse, Project} from '../../../../../core/models';
import {ProjectService} from '../../../../../core/services';
import {TokenService} from '../../../../../core/auth';

import {BreadcrumbService} from '../../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../../projectsidebar.service';

import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-project-activity-detection',
  templateUrl: './project-activity-detection.page.html'
})
export class ProjectActivityDetectionPage implements OnInit {
  project: Project;
  projectId: string;
  searchTerms = new Subject<ActivityPageRequest>();
  authUser = this.token.whoAmI();
  loading = false;

  items: MenuItem[];
  activeItem: MenuItem;

  @Input() query = new ActivityPageRequest();
  activityResponse = new ActivityResponse();


  constructor(
    private route: ActivatedRoute,
    private token: TokenService,
    private projectService: ProjectService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService,
    private router: Router
  ) {
  }

  initItems() {
    this.items = [
      {
        label: 'All', command: (event: any) => {
          this.query.event = 'DETECTION, ACCUSATION';
        }, routerLink: ['all']
      },
      {
        label: 'Detections', command: (event: any) => {
          this.query.event = 'DETECTION';
        }, routerLink: ['detections']
      },
      {
        label: 'Suspicious events', command: (event: any) => {
          this.query.event = 'ACCUSATION';
        }, routerLink: ['suspicious']
      }
    ];

    if (this.router.url.endsWith('detections')) {
      this.query.event = 'DETECTION';
      this.activeItem = this.items[1];
    } else if (this.router.url.endsWith('suspicious')) {
      this.query.event = 'ACCUSATION';
      this.activeItem = this.items[2];
    } else {
      this.query.event = 'DETECTION, ACCUSATION';
      this.activeItem = this.items[0];
    }
  }

  ngOnInit() {
    this.initItems();
    this.loading = true;
    this.route.parent.params.subscribe((params) => {
      this.projectId = params.id;
    });

    this.route.parent.data.subscribe((data) => {
      if (data.project) {
        this.project = Object.assign({}, data.project);
        this.projectSidebarService.setProject(this.project);
        this.query.projectId = this.project.id;

        this.searchTerms.pipe(debounceTime(500)).subscribe(
          (query) => {
            this.loadActivities(query);
          }
        );

        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name},
          {label: 'activity/detection'},
        ]);
      }
      this.loading = false;
    });

  }

  paginateActivities(event) {
    delete (this.query.projectId);
    this.query.page = (event.first / event.rows) + 1;
    this.query.sortField = event.sortField !== undefined ? event.sortField : 'creationDate';

    this.query.sortDir = event.sortOrder !== undefined ? this.query.getSortDir(event.sortOrder) : 'desc';

    this.loadActivities(this.query);
  }

  search(query: ActivityPageRequest): void {
    this.searchTerms.next(query);
  }

  loadActivities(query: ActivityPageRequest) {
    if (this.query.event == undefined) {
      this.query.event = 'DETECTION, ACCUSATION';
    }

    this.projectService.getActivities(this.project.id, query).subscribe(
      (data) => {
        this.activityResponse = data;
      }
    );
  }

}
